module.exports = __webpack_public_path__ + "img/map_cadiz.6765936e.png";